import Promise from 'bluebird';
import { firebase, db, countriesCollection, ordersCollection } from '@/firebase';
import { actions, mutations } from '../constants'



const mockTransactions = [];

const mockServices= [{id:1, name:'TopUp'},{id:2, name:'Wifi'}];

for(let i=1;i<=100;i++){
  const randomIdx = Math.floor(Math.random() * (1 - 0 + 1)) + 0;
  mockTransactions.push({
    id: i,
    service: mockServices[randomIdx].name,
    date: Date.now()
  })
}


const core = {
  state: {
      countries:[],
      languages:[{
        id:'es',
        name: 'Spanish',
        translations:{
          es: 'Español'
        }
      },{
        id:'en',
        name: 'English',
        translations:{
          es: 'Inglés'
        }
      }]
  },
  mutations:{
    setCountries(state, countries=[]){
      state.countries = countries;
    },
  },

  actions:{
    getCountryList({rootState, state, commit}){
      if(state.countries.length>0){
        return Promise.resolve(state.countries);
      }
      //const db = firebase.firestore();
      const countriesRef = countriesCollection;
      return countriesRef.get()
      .then(snapshot=>{
        const list = [];
        snapshot.forEach(doc=>{
          list.push(doc.data());
        });
        commit('setCountries',list);
        return Promise.resolve(list);
      });
    },



    getLanguageList({rootState, state, commit}){
      return Promise.resolve(state.languages)
    },


    [actions.CORE_GET_ORDER_HISTORY]({rootState, state, commit},{from, size, filters={}}){
      const qSize = size || 50;
      const qFrom = from || 0;
      //const db = firebase.firestore();
      //const contactRef = db.collection(`users/${rootState.auth.user.id}/contacts`);
      const ordersRef = ordersCollection;
      // Create a query against the collection
      const queryRef = ordersRef.where('user_id', '==', rootState.auth.user.id);
      return queryRef.get()
        .then(snapshot=>{
          const list = [];
          snapshot.forEach(doc=>{

            const order = Object.assign({}, doc.data());
            order.created = order.created?order.created.toDate():null;

            list.push(order);
            //list.push(Object.assign({},doc.data(),{id: doc.id}));
          });
          return list;
        })
    },

    [actions.CORE_GET_CONTACTS]({rootState, commit},{from, size, filters={}}={}){
      const qSize = size || 50;
      const qFrom = from || 0;
      //const db = firebase.firestore();
      const contactRef = db.collection(`users/${rootState.auth.user.id}/contacts`);
      //itiesRef.where('capital', '==', true).get()
      return contactRef.get()
        .then(snapshot=>{
          const list = [];
          snapshot.forEach(doc=>{
            list.push(Object.assign({},doc.data(),{id: doc.id}));
          });
          return list;
      })
    },
    createContact({rootState, commit}, payload={}){
     // const db = firebase.firestore();
      const data = Object.assign({},payload);
      const contactRef = db.collection(`users/${rootState.auth.user.id}/contacts`);
      return contactRef.add(data);
    },
    updateContact({rootState, commit}, {id, data={}}={}){
      if(!id) return false;
     // const db = firebase.firestore();
      const d = Object.assign({},data);
      const contactRef = db.collection(`users/${rootState.auth.user.id}/contacts`).doc(id);
      return contactRef.set(d, { merge: true });
    },
    deleteContact({rootState, commit}, id){
      if(!id) return false;
     // const db = firebase.firestore();
      const contactRef = db.collection(`users/${rootState.auth.user.id}/contacts`).doc(id);
      return contactRef.delete();
    }
  }
};


export default core;



// WEBPACK FOOTER //
// ./src/store/modules/core.js